/**
 * Main menu
 */
const menu = () => {

  // grab the menu
  const el = document.getElementById('menu-main');
  if (el) {

    // grab the sub elements
    const trigger = el.querySelector('.js-menu-main-trigger');
    const label = trigger.querySelector('span');
    const menu = trigger.nextElementSibling;

    // start out with the nav hidden
    menu.setAttribute('aria-hidden', true);

    // on click of the trigger show the menu (with accessibility)
    trigger.addEventListener('click', () => {
      const wasOpen = 'true' === trigger.getAttribute('aria-expanded');
      label.textContent = wasOpen ? 'Menu' : 'Close';
      trigger.setAttribute('aria-expanded', !wasOpen);
      menu.setAttribute('aria-hidden', wasOpen);
      document.body.classList.toggle('nav-active', !wasOpen);
    });
  }
}

export default menu;
